import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-link',
  templateUrl: './portal-link.component.html',
  styleUrls: ['./portal-link.component.scss']
})
export class PortalLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
